import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import SettingRemoveModal from './SettingRemoveModal'
import { IMobilityOptionObject } from 'src/types'

interface IRemoveMobilityDeviceModalProps {
  devices: any
  remove: (mobility: IMobilityOptionObject) => Promise<any>
}

interface IRemoveMobilityDeviceModalState {
  isSaving: boolean
}

export default class RemoveMobilityDeviceModal extends React.Component<
  RouteComponentProps<any> & IRemoveMobilityDeviceModalProps,
  IRemoveMobilityDeviceModalState
> {
  constructor(props: any) {
    super(props)
    this.state = {
      isSaving: false
    }
  }

  public render() {
    const device = this.props.devices[this.props.match.params.id]
    const bodyStyle: any = {
      pointerEvents: this.state.isSaving ? 'none' : 'auto',
      opacity: this.state.isSaving ? 0.4 : 1.0
    }
    return (
      <div style={bodyStyle}>
        <SettingRemoveModal
          setting={{ label: device ? device.name : '', id: device ? device.id : '' }}
          settingType='Mobility Devices'
          onRemove={this.onRemove}
          onClose={this.onClose}
        />
      </div>
    )
  }

  private onRemove = () => {
    this.setState({
      isSaving: true
    })
    const device = this.props.devices[this.props.match.params.id]
    this.props.remove(device).then(
      (result: any) => {
        setTimeout(() => {
          this.setState({
            isSaving: false
          })
          this.onClose()
        }, 100)
      },
      (err: any) => {
        setTimeout(() => {
          this.setState({
            isSaving: false
          })
          this.onClose()
        }, 100)
      }
    )
  }

  private onClose = () => {
    this.props.history.push('/global-settings/mobility-devices')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/RemoveMobilityDeviceModal.tsx